const link = {
  marginTop: '-2px',
}

export const styles = {
  link,
}
